var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffInact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.62,
    height: 51.048,
    viewBox: "0 0 36.62 51.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staff-inact",
    transform: "translate(-254.957 -207.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M272.746,221.438a7.084,7.084,0,1,0-5.008-2.072A7.082,7.082,0,0,0,272.746,221.438Z",
    transform: "translate(-9.085)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M269.915,325.535a8.517,8.517,0,0,1-3.159-13.325,8.711,8.711,0,0,0-11.8,8.145v8.84a.717.717,0,0,0,.3.559,16.573,16.573,0,0,0,8.317,2.371,10.158,10.158,0,0,1,6.34-6.591Z",
    transform: "translate(0 -88.588)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M399.619,221.438a7.091,7.091,0,1,0-5.005-2.075A7.084,7.084,0,0,0,399.619,221.438Z",
    transform: "translate(-116.766)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M404.33,311.59a8.591,8.591,0,0,0-3.109.573,8.5,8.5,0,0,1-3.152,13.317,10.18,10.18,0,0,1,6.354,6.6,16.584,16.584,0,0,0,8.317-2.364.716.716,0,0,0,.3-.559v-8.847a8.718,8.718,0,0,0-8.711-8.718Z",
    transform: "translate(-121.464 -88.541)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M329.12,311.99a7.077,7.077,0,0,0,6.2,7.027v.279a9.166,9.166,0,0,1,1.776,0v-.279a7.078,7.078,0,1,0-7.981-7.027Z",
    transform: "translate(-62.945 -82.88)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M328.018,407.912v-.279a7.547,7.547,0,0,1-.9.05,5.89,5.89,0,0,1-.874-.043v.265a8.711,8.711,0,0,0-7.823,8.675v8.847a.659.659,0,0,0,.3.552,16.475,16.475,0,0,0,8.41,2.393,16.656,16.656,0,0,0,8.411-2.385.718.718,0,0,0,.3-.559v-8.847a8.711,8.711,0,0,0-7.823-8.668Z",
    transform: "translate(-53.862 -170.056)",
    fill: "#6e6e6e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffInact);
export default __webpack_public_path__ + "static/media/staff-inact.8096be66ca2cdc44a23d3d8e254e7e00.svg";
export { ForwardRef as ReactComponent };